import styled from 'styled-components';
import { BottomNavigation as MuiBottomNavigation } from '@mui/material';

const BottomBar = styled(MuiBottomNavigation)`
  border-radius: 50rem;
`;

export default BottomBar;
